import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import {
    Container,
    Row,
    Col,
    Table,
    Card,
    CardBody,
} from "reactstrap"
import CardItem from "./CardItem"
import Paginator from "components/Common/Paginator/Paginator"
import AppoinmentService from "services/Provider/AppoinmentService"
import "./styles.scss"
import FilterModal from "./FilterModal"
import FilterIcon from "assets/images/filter.png"
import FeedbackModal from "./FeedbackModal"
import StatusButton from "./StatusButton"
import moment from "moment"
import { providerPrefix } from "configs/routePrefix"
import { useDispatch } from "react-redux"
import { appendFilters } from "store/adminFilter/actions"

 
const AppoinmentsPage = (props) => {
    const appoinmentService = new AppoinmentService()
    const [status, setStatus] = useState('All')
    const [modal, setModal] = useState(false)
    const [filterData, setFilterData] = useState({
        from_date: "",
        to_date: ""
    })
    const [searchWord, setSearchWord] = useState("")
    const [list, setList] = useState([])
    const [filtersParams, setFilterParams] = useState(null)
    const [shouldGetData, setShouldGetData] = useState(false)
    const [pageOptions, setPageOptions] = useState({
        sizePerPage: 10,
        totalSize: 1,
    })
    const dispatch = useDispatch()

    useEffect(()=>{
        dispatch(appendFilters({developer_id: null}))
    },[])


    const toggle = () => {
        setModal(!modal)
    }

    const OnSearchChange = (e) => {
        const search = e.target.value
        setSearchWord(search)
    }


    const addHandler = () => {
        props.history.push(`${providerPrefix}/appoinments/book-appoinment`)
    }

    useEffect(() => {
        // debounce solution to reduce request data from api
        const timeoutId = setTimeout(() => {
            const params = {}
            if (status != 'All') params['status'] = status
            if (searchWord.trim().length) params['keyword'] = searchWord
            if (filterData ?.from_date ?.length && filterData ?.to_date ?.length) {
                 params['date_range'] = `${filterData.from_date},${filterData.to_date}`
            } else if (filterData ?.from_date ?.length) {
                params['date_range'] = `${filterData.from_date},${moment().format(`YYYY-MM-DD`)}`
            } else if (filterData ?.to_date ?.length) {
                params['date_range'] = `0,${filterData.to_date}`
            }
            setFilterParams({ ...params })
        }, 1000)

        return () => clearTimeout(timeoutId)
    }, [status, searchWord, filterData.from_date,filterData.to_date])

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>Appoinments</title>
                </MetaTags>
                <Container fluid>
                    <Row className="mb-1">
                        <Col md={6}>
                            <h4>Manage Appointments</h4>
                        </Col>
                    </Row>
                    <Row className="mb-2">
                        <Col md={6}>
                            <div className="form-group has-search">
                                <span className="fa fa-search form-control-feedback"></span>
                                <input type="text" className="form-control" placeholder="Search by Appointment Title, Client Name, I.D" onChange={(e) => OnSearchChange(e)}
                                    value={searchWord} />
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="d-md-flex justify-content-md-end mb-2">
                                <button
                                    className="btn btn-success btnHeight px-lg-4"
                                    onClick={addHandler}
                                >
                                    Add New Appoinment
                                    </button>
                            </div>
                        </Col>
                    </Row>
                    <Row className="mb-4">
                        <Col sm={8} className="mb-3">
                            <StatusButton statusValue={status} status={"All"} setStatus={setStatus} />
                            <StatusButton statusValue={status} status={"Upcoming"} setStatus={setStatus} />
                            <StatusButton statusValue={status} status={"Done "} setStatus={setStatus} />
                            <StatusButton statusValue={status} status={"Canceled"} setStatus={setStatus} />

                        </Col>
                        <Col sm={4} className="mb-3 d-flex flex-row-reverse">

                            <button className="btn btnUpload btnHeight px-4" style={{ margin: "0" }} onClick={() => {
                                setModal(!modal)
                            }}> <img src={FilterIcon} style={{ marginRight: "5px" }} />Filter</button>
                        </Col>
                    </Row>
                    <div>
                        <Card className="w-100 mt-4">
                            <CardBody>
                                <div className="py-3">
                                    <div>
                                        <div className="table-responsive-crm">
                                            <Table>
                                                <thead>
                                                    <tr className="bgHeaderTable">
                                                        <th className="font-size-14">
                                                            I.D
                                                        </th>
                                                        <th className="font-size-14">Title</th>
                                                        {/* <th className="font-size-14">Lead Name</th> */}
                                                        <th className="font-size-14">Date</th>
                                                        <th className="font-size-14">time</th>
                                                         <th className="font-size-14">Type</th>
                                                        <th className="font-size-14">Status</th>
                                                        <th className="font-size-14"></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {list.map((item, index) => {
                                                        return (
                                                            <CardItem
                                                                key={index}
                                                                item={item}
                                                                history={props.history}
                                                                setShouldGetData={setShouldGetData}
                                                            />
                                                        )
                                                    })}
                                                </tbody>
                                            </Table>
                                        </div>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                        <Row className="d-flex justify-content-end">
                            <Col className="d-flex justify-content-between" md={12} sm={12}>
                                <Paginator
                                    service={appoinmentService}
                                    pageOptions={pageOptions}
                                    setData={(data) => setList([...data])}
                                    setPageOptions={setPageOptions}
                                    filtersParams={filtersParams}
                                    shouldGetData={shouldGetData}
                                    setShouldGetData={setShouldGetData}
                                />
                            </Col>
                        </Row >
                        {modal ? <FilterModal
                            toggle={toggle}
                            modal={modal}
                            onSumbit={(data) => setFilterData((prevData) => ({ ...prevData, ...data }))}
                            filterData={filterData}
                        />:null}
                        {/* <FeedbackModal  modal={feedbackModal} toggle={()=>setFeedbackModal(!feedbackModal)}/> */}
                    </div>
                </Container>
            </div>
        </React.Fragment >
    )
}

export default AppoinmentsPage
